import { DSDataLayer, DSPostMeta, LinkedLinkProps } from 'shared-definitions/types'
import { ApiSluggedLink, ApiSponsorInfoProps } from 'data-source/types.wp'
import { sponsorInfoMapper } from 'data-source/mappers/sponsorInfoMapper'
import { PLinkMapperOpts } from './pLinkMapper'
import { sluggedLinkMapper } from './sluggedLinkMapper'

export interface MetaMapperOpts extends PLinkMapperOpts {
  tagLinkBuilder: (slug: string) => LinkedLinkProps
}

interface InputProps extends ApiSponsorInfoProps {
  content?: { ID?: number; engagement_container_id?: string }
  head?: { datalayer?: DSDataLayer }
  categories?: ApiSluggedLink[]
  tags?: ApiSluggedLink[]
  topics?: ApiSluggedLink[]
}

/* eslint-disable @typescript-eslint/naming-convention */
export function metaMapper(
  input: InputProps,
  subscribeTags: readonly string[],
  opts: MetaMapperOpts
): DSPostMeta {
  const postId = input.content && input.content.ID ? input.content.ID : null
  return {
    dataLayer: input.head?.datalayer ?? null,
    subscribeTags,
    engagementContainerId: input.content?.engagement_container_id ?? null,
    postId,
    categories: (input?.categories ?? []).map(i => ({
      ...sluggedLinkMapper(i, opts),
      slug: i.slug,
    })),
    topics: (input?.topics ?? []).map(i => ({ ...sluggedLinkMapper(i, opts), slug: i.slug })),
    tags: (input?.tags ?? []).map(i => ({ ...sluggedLinkMapper(i, opts), slug: i.slug })),
    disabledAds: input.disable_ads ?? false,
    ...sponsorInfoMapper(input),
  }
}
